export default "__VITE_ASSET__Cvb2lXni__"